import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { getActiveBanner } from 'utils/bolt/showtimes';
import { getValueForClientSize, isVideosPage } from 'utils/bolt';
import HTML from 'components/core/html/html';
import s from 'components/bolt/sidePanel/notificationBanner.sss';

const isExternalLink = str => /^(https?:)?\/\//.test(str);

export default class NotificationBanner extends Component {

	constructor(props) {
		super(props);

		this.state = {
			activeItem: 0,
			noRotations: true
		};

		this.iterate = this.iterate.bind(this);
		this.handleOnClick = this.handleOnClick.bind(this);
		this.onAnimationEnd = this.onAnimationEnd.bind(this);
		this.triggerItemClick = this.triggerItemClick.bind(this);
		this.getBannerHeight = this.getBannerHeight.bind(this);

		const store = Store.get();
		this.fontStyles = store.appData?.styling?.fontVariables;
		this.copy = store.appData?.copy?.baseCopy || {};

		const activePage = store?.activePage;
		const bannerPath = `bolt${this.props.isHomeEnt ? 'HomeEnt' : 'Showtimes'}.data.notificationBanner`;

		this.banners = accessNested(store, `appData.pages.${activePage}.data.${bannerPath}`, null) || accessNested(store, `appData.pages.${bannerPath}`, null);
		this.updateBanner();
		this.bannerRefs = {};
	}

	componentDidMount() {
		const autoRotate = this.activeBanner?.autoRotate;
		if (autoRotate && this.numberOfTouts > 1) {
			this.startIterating(autoRotate);
		}

		this.getBannerHeight();
		window.addEventListener('resize', this.getBannerHeight);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.region !== this.props.region || prevProps.movies !== this.props.movies) {
			this.updateBanner();
		}
		if (this.props.listOrMapMode === 'map' && (prevProps.listOrMapMode !== this.props.listOrMapMode)) {
			this.setState({ noRotations: true });
		}
	}

	componentWillUnmount() {
		this.stopIterating();
	}

	updateBanner() {
		let prev = this.activeBanner;
		const userCountry = this.props.region || '';

		let banners = this.banners;
		let activeMovies = Object.keys(this.props.movies || {});
		if (banners && activeMovies.length === 1) {
			const overrides = banners[activeMovies[0]] || {};
			banners = Object.assign({ ...banners }, overrides);
		}

		this.activeBanner = getActiveBanner(banners, userCountry.toUpperCase());
		this.carouselItems = sortObjectByOrder(this.activeBanner?.contentCarousel);
		this.numberOfTouts = this.carouselItems.length;
		const autoRotate = this.activeBanner?.autoRotate;
		if (!prev?.autoRotate !== !autoRotate && typeof window !== 'undefined') {
			autoRotate ? this.startIterating(autoRotate) : this.stopIterating();
		}
	}

	startIterating(autoRotate) {
		clearInterval(this.interval);
		this.interval = setInterval(this.iterate, autoRotate * 1000);
	}
	stopIterating() {
		clearInterval(this.interval);
	}

	getBannerHeight() {
		if (!this.carouselWrapper || this.activeBanner?.sideBySide) {
			return;
		}
		let heights = Object.values(this.bannerRefs).map(banner => banner?.getBoundingClientRect()?.height || 0);
		let height = Math.max(0, ...heights);
		if (this.props.inListOrMapView === 'list') {
			this.carouselWrapper.style.height = height + 'px';
		}
	}

	handleOnClick() { }

	triggerItemClick(item) {
		this.handleOnClick();
		const { path, label } = item || {};
		if (!path) {
			return;
		}

		Store.emit('NOTIFICATION_BANNER_CLICK', this.props.isShowtimes ? 'showtimes' : 'homeent', 'notificationBanner', label);

		if (isExternalLink(path)) {
			return;
		}

		if (path.startsWith('@')) {
			return Store.emit('OPEN_RESERVED_VARIABLE_LINK', path);
		} else if (isVideosPage(path)) {
			return Store.emit('OPEN_VIDEO_OVERLAY', path);
		} else if (path === 'boltShowtimes') {
			return Store.emit('SHOWTIMES_SHOW', true);
		} else if (path === 'boltHomeEnt') {
			return Store.emit('HOMEENT_SHOW', true);
		} else {
			return Store.emit('CLOSE_AND_NAVIGATE', path);
		}
	}

	iterate() {
		const { activeItem } = this.state;
		let newItem = activeItem + 1;
		if (newItem >= this.numberOfTouts) {
			newItem = 0;
		}
		this.newItem = newItem;
		this.setState({ fadeOut: true, noRotations: false });
		if (this.props.inListOrMapView !== this.props.listOrMapMode) {
			this.setState({ activeItem: newItem });
		}
	}

	onAnimationEnd(e) {
		if (!this.banner) {
			return;
		}
		const isTarget = e.target === this.banner;
		const opacity = getComputedStyle(this.banner).opacity;
		if (isTarget && parseInt(opacity) === 0) {
			this.setState({ fadeOut: false, activeItem: this.newItem });
		}
	}

	getImageSrc(tout) {
		let src;
		if (!tout.mobileSrc && !tout.tabletSrc) {
			src = tout.desktopSrc;
		} else {
			src = {
				desktop: tout.desktopSrc,
				mobile: tout.mobileSrc,
				tablet: tout.tabletSrc
			};
		}
		return getValueForClientSize(src);
	}

	renderTout(tout, index, isSizer) {
		if (!tout) {
			return;
		}
		const props = this.props;
		const { fadeOut, noRotations } = this.state;
		const image = this.getImageSrc(tout);
		const label = this.copy[tout.label] || tout.label || 'banner';
		const path = tout.path;


		let content = <HTML content={label} markdown />;
		if (image) {
			content = <img src={image} class={s.image} alt={label} ariaLabel={label} onLoad={this.getBannerHeight} />;
		}
		let refParent = isSizer ? this.bannerRefs : this;
		let refKey = (isSizer ? 'sizer' : 'banner') + (index !== undefined ? index : '');

		let toutProps = {
			onClick: () => this.triggerItemClick(tout),
			onAnimationEnd: this.onAnimationEnd,
			ref: ref => refParent[refKey] = ref,
			class: joinClasses(
				s.banner,
				props.isShowtimes && this.fontStyles.notificationBanner,
				props.isHomeEnt && s.homeEnt,
				props.isHomeEnt && this.fontStyles.homeEntBanner,
				this.numberOfTouts > 1 && s.isCarousel,
				!noRotations && !isSizer && (fadeOut ? s.fadeOut : s.fadeIn),
				path && s.clickable,
				isSizer && s.sizer,
				image && s.isImage
			),
			ariaHidden: isSizer,
			key: refKey
		};

		if (isExternalLink(path)) {
			return <a {...toutProps} href={path} target={tout.sameWindow ? '_self' : '_blank'}>{content}</a>;
		} else if (path) {
			return <button {...toutProps}>{content}</button>;
		}
		return <div {...toutProps}>{content}</div>;
	}

	render(props, { activeItem }) {
		if (!this.activeBanner) {
			return;
		}

		if (this.activeBanner.label || this.getImageSrc(this.activeBanner)) {
			return this.renderTout(this.activeBanner);
		} else if (this.numberOfTouts === 1) {
			return this.renderTout(this.carouselItems[activeItem]);
		}

		let content = [];
		if (this.activeBanner.sideBySide) {
			content = [
				...this.carouselItems.map((item, i) => this.renderTout(item, i)),
			];
		} else {
			content = [
				...this.carouselItems.map((item, index) => this.renderTout(item, index, true)),
				this.renderTout(this.carouselItems[activeItem]),
				this.numberOfTouts > 1 && (
					<div class={s.progress}>
						{this.carouselItems.map((_, index) => <div class={joinClasses(s.dot, activeItem === index && s.active)} />)}
					</div>
				)
			];
		}

		return (
			<div class={joinClasses(s.carouselWrapper, this.activeBanner.sideBySide && s.sideBySide)} ref={ref => this.carouselWrapper = ref}>
				{content}
			</div>
		);
	}
}
